import { Button, Modal, Form, Row, Col, message, Input } from "antd";
import { useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {  handleRejectRequest } from "../../../../api/requests";
import formatMoney from "../../../../utils/formatMoney";

export default function RejectRequest({
  isVisible,
  setVisible,
  request,
  id,
  type,
  selected,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleRejectRequest,
    onSuccess: () => {
      message.success("Rejected Successfully");
      form.resetFields();
      setVisible(false);
      queryClient.invalidateQueries({ queryKey: ["requests", id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { remarks } = await form.getFieldsValue();
    const data = { isApproved: true,  approverId: selected?._id, remarks, type };
    await mutate({ _id: request?._id, data });
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Reject Credit Limit Request"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="rejectRequest"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Reject
        </Button>,
      ]}
    >
      <Form
        id="rejectRequest"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        {/* <div>
          Reject the request for
          <span className="font-bold mx-1">Credit Limit</span>
          <span className="font-bold text-red-600 text-center">
            {formatMoney(request?.requestedLimit)} /= TZS
          </span>
        </div> */}
                <div>
          <div className="">
          Reject the request for
            <span className="font-bold mx-1">Credit Limit</span>
          </div>
          <div className="font-bold text-red-600 text-center">
            {formatMoney(request?.requestedLimit)} /= TZS
          </div>
        </div>

        <div className="mb-6">
          To Customer :{" "}
          <span className="font-bold">{request?.customerName}</span>
        </div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="remarks"
              label="Remarks ( Optional )"
              rules={[
                {
                  required: false,
                  message: `Please enter remarks`,
                },
              ]}
            >
              <Input placeholder="Remarks" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
